module.exports = __webpack_public_path__ + "static/media/woman-cta.5c2b66ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/woman-cta.png
// module id = 2518
// module chunks = 0